import script from "./MobileNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileNavbar.vue?vue&type=script&setup=true&lang=js"

import "./MobileNavbar.vue?vue&type=style&index=0&id=1a893ed6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a893ed6"]])

export default __exports__